const envLang = process.env.REACT_APP_LOCALE || 'en';

export const CrossDomainHelper = {
  decorateTrackingUrl: (urlString, trackingId) => {
    const ga = window[window['GoogleAnalyticsObject']];
    if (ga && ga.getAll) {
      var trackers = ga.getAll().filter(function (t) {
        return trackingId ? t.get('trackingId') === trackingId : true;
      });
      var tracker = trackers.length ? trackers[0] : undefined;
      if (tracker) {
        urlString = new window.gaplugins.Linker(tracker).decorate(urlString);
      }
    }
    return urlString;
  },

  coverToTrackingLinkInJP: (urlString) => {
    if (envLang === 'ja') {
      return CrossDomainHelper.decorateTrackingUrl(urlString);
    }
    return urlString;
  },
};
